import type { Element } from '@xmldom/xmldom'
import _ from 'lodash'
import L6ToL5TagProcessor from "./TagProcessor"
import { DefaultProps, applyDefaultCid } from "./DefaultProps"
import { setNodeError } from "./L6ToL5Processor"
import { CidPath } from '../../concept/Concept'
import { Directory } from '../../directory/Directory'

export const ERR_VALUELISTNAME_EXPECTED = 'valueListName expected but not found'
export const ERR_VALUELIST_NOT_FOUND = (valueListName: string) => `ValueList ${valueListName} not found`

class ValueListTagProcessor extends L6ToL5TagProcessor {
	getNodeValueList(node: Element): ReturnType<Directory["getValuelist"]>|null {
		let valueListName = node.getAttribute('name')
		if(valueListName === null) {
			setNodeError(node, ERR_VALUELISTNAME_EXPECTED, true)
			return null
		}
		let valueList = this.rootProc.directory.getValuelist(valueListName)
		if(!valueList) {
			setNodeError(node, ERR_VALUELIST_NOT_FOUND(valueListName), true)
			return null
		}
		return valueList
	}

	processList(node: Element, xpath: string, baseCidPath: CidPath, defaultProps: DefaultProps, listNodeTagName: string) {
		const valueList = this.getNodeValueList(node)
		if(!valueList) {
			return
		}
		applyDefaultCid(node, defaultProps)
		const cid = node.getAttribute('cid')
		const ignoreValues: string[] = node.getAttribute('ignoreValues')?.split('|') ?? []
		// via getConcept the xpath of this list gets added to the
		// concept xpaths
		this.rootProc.getConcept(node, xpath, baseCidPath)
		_.forEach(valueList, value => {
			if(ignoreValues.includes(value.Value)) {
				return
			}
			// if not a Select control (containing Options)
			// skip dropdown menu breaks
			if(value.Value == '-' && listNodeTagName != 'Option') {
				return
			}
			let valueNode = this.rootProc.doc.createElement(listNodeTagName)
			if(cid) {
				valueNode.setAttribute('cid', cid)
			}
			valueNode.setAttribute('subconceptCid', value.Cid)
			valueNode.setAttribute('title', value.Value)
			let [concept, subconcept] = this.rootProc.getSubconcept(valueNode, xpath, baseCidPath)
			if(concept !== null && subconcept !== null) {
				concept.subconcepts.push(subconcept.cid)
			}
			node.appendChild(valueNode)
		})
	}
}

export default ValueListTagProcessor
